import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from '@/store/app'
import appConfig from '@/store/app-config'
import verticalMenu from '@/store/vertical-menu'
import commonStoreModule from '@/store/commonStoreModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    // 'app-ecommerce': ecommerceStoreModule,
    'app-common': commonStoreModule,
  },
  strict: process.env.DEV,
})
